import {
  useEffect,
  useState
} from "react";

import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaUsers
} from "react-icons/fa";

import MainLayout from "../../components/layout/MainLayout";

import {
  getCustomers,
  createCustomer,
  updateCustomer,
  deleteCustomer
} from "../../api/customerApi";

const Customers = () => {

  const [customers, setCustomers] =
    useState([]);

  const [showModal, setShowModal] =
    useState(false);

  const [editingId, setEditingId] =
    useState(null);

  const [form, setForm] =
    useState({

      customer_name: "",
      contact_person: "",
      mobile: "",
      email: "",
      gst_no: "",
      address: "",
      credit_limit: "",
      payment_terms: "",
      status: "active"

    });

  useEffect(() => {

    loadCustomers();

  }, []);

  const loadCustomers =
    async () => {

      try {

        const res =
          await getCustomers();

        setCustomers(
          res.data.data || []
        );

      }
      catch (error) {

        console.log(error);

      }

    };

  const resetForm = () => {

    setEditingId(null);

    setForm({

      customer_name: "",
      contact_person: "",
      mobile: "",
      email: "",
      gst_no: "",
      address: "",
      credit_limit: "",
      payment_terms: "",
      status: "active"

    });

  };

  const saveCustomer =
    async (e) => {

      e.preventDefault();

      try {

        if (editingId) {

          await updateCustomer(
            editingId,
            form
          );

        }
        else {

          await createCustomer(
            form
          );

        }

        loadCustomers();

        setShowModal(false);

        resetForm();

      }
      catch (error) {

        console.log(error);

      }

    };

  const editCustomer =
    (customer) => {

      setEditingId(customer.id);

      setForm(customer);

      setShowModal(true);

    };

  const removeCustomer =
    async (id) => {

      if (
        !window.confirm(
          "Delete Customer?"
        )
      ) return;

      await deleteCustomer(id);

      loadCustomers();

    };

  return (

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header bg-white d-flex justify-content-between align-items-center">

          <div>

            <h5 className="mb-0">
              Customer Master
            </h5>

            <small className="text-muted">
              Manage Customers
            </small>

          </div>

          <button
            className="btn btn-primary"
            onClick={() =>
              setShowModal(true)
            }
          >

            <FaPlus />
            {" "}
            Add Customer

          </button>

        </div>

        <div className="card-body">

          <table className="table table-hover align-middle">

            <thead>

              <tr>

                <th>Customer</th>
                <th>Contact</th>
                <th>Mobile</th>
                <th>Credit Limit</th>
                <th>Payment Terms</th>
                <th>Status</th>
                <th>Action</th>

              </tr>

            </thead>

            <tbody>

              {
                customers.map((item) => (

                  <tr key={item.id}>

                    <td>

                      <FaUsers
                        className="text-primary me-2"
                      />

                      {item.customer_name}

                    </td>

                    <td>
                      {item.contact_person}
                    </td>

                    <td>
                      {item.mobile}
                    </td>

                    <td>
                      ₹ {item.credit_limit}
                    </td>

                    <td>
                      {item.payment_terms} Days
                    </td>

                    <td>

                      <span
                        className={
                          item.status === "active"
                            ? "badge bg-success"
                            : "badge bg-danger"
                        }
                      >

                        {item.status}

                      </span>

                    </td>

                    <td>

                      <button
                        className="btn btn-warning btn-sm me-2"
                        onClick={() =>
                          editCustomer(item)
                        }
                      >

                        <FaEdit />

                      </button>

                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() =>
                          removeCustomer(item.id)
                        }
                      >

                        <FaTrash />

                      </button>

                    </td>

                  </tr>

                ))
              }

            </tbody>

          </table>

        </div>

      </div>

      {showModal && (

        <div
          className="modal d-block"
          style={{
            background:
              "rgba(0,0,0,.5)"
          }}
        >

          <div className="modal-dialog modal-lg">

            <div className="modal-content">

              <form
                onSubmit={saveCustomer}
              >

                <div className="modal-header">

                  <h5>

                    {
                      editingId
                        ? "Edit Customer"
                        : "Add Customer"
                    }

                  </h5>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {

                      setShowModal(false);

                      resetForm();

                    }}
                  />

                </div>

                <div className="modal-body">

                  <div className="row">

                    <div className="col-md-6 mb-3">

                      <label>
                        Customer Name
                      </label>

                      <input
                        className="form-control"
                        value={form.customer_name}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            customer_name:
                              e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Contact Person
                      </label>

                      <input
                        className="form-control"
                        value={form.contact_person}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            contact_person:
                              e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Mobile
                      </label>

                      <input
                        className="form-control"
                        value={form.mobile}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            mobile:
                              e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Email
                      </label>

                      <input
                        className="form-control"
                        value={form.email}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            email:
                              e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Credit Limit
                      </label>

                      <input
                        className="form-control"
                        value={form.credit_limit}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            credit_limit:
                              e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-6 mb-3">

                      <label>
                        Payment Terms (Days)
                      </label>

                      <input
                        className="form-control"
                        value={form.payment_terms}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            payment_terms:
                              e.target.value
                          })
                        }
                      />

                    </div>

                    <div className="col-md-12">

                      <label>
                        Address
                      </label>

                      <textarea
                        rows="3"
                        className="form-control"
                        value={form.address}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            address:
                              e.target.value
                          })
                        }
                      />

                    </div>

                  </div>

                </div>

                <div className="modal-footer">

                  <button
                    className="btn btn-primary"
                  >

                    Save Customer

                  </button>

                </div>

              </form>

            </div>

          </div>

        </div>

      )}

    </MainLayout>

  );

};

export default Customers;